/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the QuotaExceededHitsBucket interface.
 */
export function instanceOfQuotaExceededHitsBucket(value) {
    if (!('distinctUsers' in value) || value['distinctUsers'] === undefined)
        return false;
    if (!('totalEvents' in value) || value['totalEvents'] === undefined)
        return false;
    return true;
}
export function QuotaExceededHitsBucketFromJSON(json) {
    return QuotaExceededHitsBucketFromJSONTyped(json, false);
}
export function QuotaExceededHitsBucketFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'distinctUsers': json['distinctUsers'],
        'totalEvents': json['totalEvents'],
    };
}
export function QuotaExceededHitsBucketToJSON(json) {
    return QuotaExceededHitsBucketToJSONTyped(json, false);
}
export function QuotaExceededHitsBucketToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'distinctUsers': value['distinctUsers'],
        'totalEvents': value['totalEvents'],
    };
}
